import request from '@/utils/request'

// api地址
const api = {
  unclearlist: 'cleaner/unclearlist',
  detail: 'cleaner/detail',
  acceptTask: 'cleaner/acceptTask',
  usertasklist: 'cleaner/usertasklist',
  getCleanerInfo: 'cleaner/getCleanerInfo',
  completeTask: 'cleaner/completeTask',
  login: 'cleaner/cleanerLogin',
  loginByCode: 'cleaner/loginByCode',
  daysOrder: 'cleaner/daysOrder',
}

// 未处理订单列表
export const unclearlist = (param) => {
  return request.post(api.unclearlist, param)   
}

// 订单详情
export const detail = (param) => {
  return request.post(api.detail, param)
}

// 接受任务
export const acceptTask = (param) => {
  return request.post(api.acceptTask, param)
}

// 用户任务列表
export const usertasklist = (param) => {
  return request.post(api.usertasklist, param)
}

// 获取清洁员信息
export const getCleanerInfo = (param, options = {}) => {
  return request.post(api.getCleanerInfo, param, { ...options })
}

// 完成任务
export const completeTask = (param) => {
  return request.post(api.completeTask, param)
}

// 登录
export const login = (param) => {
  return request.post(api.login, param, { skipAuth: true, load: true })
}

// 登录通过code
export const loginByCode = (param) => {
  return request.post(api.loginByCode, param, { skipAuth: true, load: true, isPrompt: true })
}

export const daysOrderList = (param) => {
  return request.post(api.daysOrder, param)
}